import "./Moving.css";
import MovingCard from "../../../assets/dr-callis-moving.png";

const Moving = () => {
  return (
    <div className="home-moving">
      <h1 className="moving-header">
        Get your speciality medications through our clinic!
      </h1>
      <p>
        Managing your rheumatologic condition can be challenging. NKY Arthritis
        is here to help you fill your Specialty medications and coordinate your
        care. This can include Oral, SubQ, and Infusion Specialty medications.
        With our in-office Medical Integrated Dispensing (MID) Program, our team
        of pharmacists and care coordinators can help you understand the
        complexities of your prescription benefits. We’re here to help reduce
        the financial, logistical, and time consuming barriers to receiving your
        Specialty medication. Talk to your care team during your next
        appointment to find out if we can fill your prescription at our clinic
        or call our MID Program at <a href="tel:8592051733">(859) 205-1733</a>.{" "}
        <a href="/clinic-medications">Click here to learn more</a>
      </p>
    </div>
  );
};

export default Moving;
